module.exports = __webpack_public_path__ + "img/Belize.0c2377e7.svg";